import { render, staticRenderFns } from "./SpeechInputModal.vue?vue&type=template&id=2438ef8d"
import script from "./SpeechInputModal.vue?vue&type=script&lang=js"
export * from "./SpeechInputModal.vue?vue&type=script&lang=js"
import style0 from "./SpeechInputModal.vue?vue&type=style&index=0&id=2438ef8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports